import { Component, Input } from "@angular/core";

export interface EmployeeInfoDisplayModel {
	name?: string;
	registration?: string;
	profileImagePath?: string;
}

@Component({
	selector: "app-employee-info-display",
	templateUrl: "./employee-info-display.component.html",
	styleUrls: ["./employee-info-display.component.scss"],
})
export class EmployeeInfoDisplayComponent {
	@Input() employee: EmployeeInfoDisplayModel | null = null;
}
